export default "__VITE_ASSET__CgwjMA4p__"